import React from 'react';
import { Bug, Compass, CreditCard, MessageSquareText, Microscope, Rocket, Settings, Sparkles, Users } from 'lucide-react';
import { SubscriptionTier } from '@/types';

export interface NavItem {
  path: string;
  label: string;
  icon?: React.ReactNode;
  active: boolean;
  hasChildren?: boolean;
  children?: NavItem[];
  onClick?: () => void;
  isNew?: boolean;
  requiredTier?: SubscriptionTier[];
  adminOnly?: boolean;
}

export const getNavItems = (
  pathname: string,
  setShowBugReport: (show: boolean) => void,
  _isMobile: boolean = false
): NavItem[] => {
  const baseItems: NavItem[] = [
    {
      path: '/dashboard',
      label: 'Dashboard',
      icon: <Compass size={20} />,
      active: pathname.startsWith('/dashboard'),
    },
    {
      path: '/purchase',
      label: 'Training Plans',
      icon: <CreditCard size={20} />,
      active: pathname.startsWith('/purchase'),
    },
    {
      path: '/models',
      label: 'Models',
      icon: <Sparkles size={20} />,
      active: pathname.startsWith('/models') || pathname.startsWith('/maplept'),
    },
    {
      path: '/research',
      label: 'Research',
      icon: <Microscope size={20} />,
      active: pathname.startsWith('/research'),
    },
    {
      path: '/agents',
      label: 'Deployments',
      icon: <Rocket size={20} />,
      active: pathname.startsWith('/agents'),
    },
    {
      path: '/settings',
      label: 'Settings',
      icon: <Settings size={20} />,
      active: pathname.startsWith('/settings'),
    },
    {
      path: '/users',
      label: 'Users',
      icon: <Users size={20} />,
      active: pathname.startsWith('/users'),
    },
    {
      path: '/support/inbox',
      label: 'Support Chat',
      icon: <MessageSquareText size={20} />,
      active: pathname.startsWith('/support/inbox'),
      adminOnly: true,
    },
    {
      path: '/access-control',
      label: 'Access Control',
      icon: <Settings size={20} />,
      active: pathname.startsWith('/access-control'),
      requiredTier: ['enterprise'],
    },

    {
      path: '#',
      label: 'Report a Bug',
      icon: <Bug size={20} />,
      onClick: () => setShowBugReport(true),
      active: false,
    },
  ];

  return baseItems;
};